import { Controller } from "stimulus"
const MINIMUM_DURATION = 5
const MAX_DURATION = 360
export default class extends Controller {
  static targets = ['appointmentDuration', 'minimumDurationMessage', 'maxDurationMessage']

  connect() {
    this.durationChange()
  }

  handleSubmit(event) {
    if (this.getDuration() < MINIMUM_DURATION || this.getDuration() > MAX_DURATION ) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }

  getDuration() {
    return Number(this.appointmentDurationTarget.value.replace(/\D/g, ""))
  }

  durationChange() {
    const duration = this.getDuration()
    if (duration < MINIMUM_DURATION) {
      this.minimumDurationMessageTarget.classList.remove('tw-hidden');
      return
    }
    if (duration > MAX_DURATION) {
      this.maxDurationMessageTarget.classList.remove('tw-hidden');
      return
    }
    this.minimumDurationMessageTarget.classList.add('tw-hidden');
    this.maxDurationMessageTarget.classList.add('tw-hidden');
  }
}
